import { render } from "./ModalManageFile.vue?vue&type=template&id=484d43c8"
import script from "./ModalManageFile.vue?vue&type=script&lang=js"
export * from "./ModalManageFile.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__